import React from "react";

// const image =  <div><a href="https://www.amazon.co.uk/Cantu-Butter-Leave-Conditioning-Repair/dp/B00449W12S/ref=as_li_ss_il?dchild=1&keywords=natural+afro+hair+products&qid=1586284380&sr=8-5&linkCode=li2&tag=natural036-21&linkId=0a2e111155faf1557940a868ddabadd7" target="_blank"><img border="0" src="//ws-eu.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B00449W12S&Format=_SL160_&ID=AsinImage&MarketPlace=GB&ServiceVersion=20070822&WS=1&tag=natural036-21" /></a><img src="https://ir-uk.amazon-adsystem.com/e/ir?t=natural036-21&l=li2&o=2&a=B00449W12S" width="1" height="1" border="0" alt="" style={{border: "none !important", margin: "0px !important"}} /></div>
// const image = <div></div>

// Instructions
// number of products [25]

// copy text only link
// copy image medium link
// add closing tag to first img (/  before img src=    here--->  ** ></a><img src=")
// set styling according to jsx - (same as this...) style={{border: "none !important", margin: "0px !important"}}
// set id
// add type  "shampoo" "leave-in conditioner" "wash out conditioner" "detangler" "tool" (does nothing now, could later)
// add title
// add description
// add option

// template
// ,
// {
//   id: 1,
//   type: "product",
//   title: "**Title of product here**",
//   imgSrc:
//     <div>**amazon image link here**</div>,
//   link: "https://amzn.to/xxxxxxxx",
//   description:
//     "Some quick example text to build on the card title and make up the bulk of the card's content. this length.",
//   option: ["1 and 1", "3 and 3", "2 and 2"]
// }

const data = [
  {
    id: 1,
    type: "product",
    title: "Cantu Shea Butter Leave-in Conditioner",
    imgSrc: (
      <div>
        <a
          href="https://www.amazon.co.uk/Cantu-Butter-Leave-Conditioning-Repair/dp/B00449W12S/ref=as_li_ss_il?dchild=1&keywords=natural+afro+hair+products&qid=1586284380&sr=8-5&linkCode=li2&tag=natural036-21&linkId=0a2e111155faf1557940a868ddabadd7"
          target="_blank"
        >
          <img
            border="0"
            src="//ws-eu.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B00449W12S&Format=_SL160_&ID=AsinImage&MarketPlace=GB&ServiceVersion=20070822&WS=1&tag=natural036-21"
          />
        </a>
        <img
          src="https://ir-uk.amazon-adsystem.com/e/ir?t=natural036-21&l=li2&o=2&a=B00449W12S"
          width="1"
          height="1"
          border="0"
          alt=""
          style={{ border: "none !important", margin: "0px !important" }}
        />
      </div>
    ),
    link: "https://amzn.to/2XgKEMN",
    description:
      "Repair cream that contains shea butter and natural oils that help manage moisture and strengthen hair",
    option: ["1 and 1", "1 and 2", "2 and 1"]
  },
  {
    id: 2,
    type: "product",
    title: "Detangling brush",
    imgSrc: (
      <div>
        <a
          href="https://www.amazon.co.uk/BESTOOL-Detangling-Hair-Detangler-Conditioner-Texture-Easy/dp/B0772M7W4N/ref=as_li_ss_il?dchild=1&keywords=afro+hair+products&qid=1586766439&refinements=p_72:419153031&rnid=419152031&sr=8-2&linkCode=li3&tag=natural036-21&linkId=b50cca82c372924f73fe1c5513151fcf"
          target="_blank"
        >
          <img
            border="0"
            src="//ws-eu.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B0772M7W4N&Format=_SL160_&ID=AsinImage&MarketPlace=GB&ServiceVersion=20070822&WS=1&tag=natural036-21"
          />
        </a>
        <img
          src="https://ir-uk.amazon-adsystem.com/e/ir?t=natural036-21&l=li3&o=2&a=B0772M7W4N"
          width="1"
          height="1"
          border="0"
          alt=""
          style={{ border: "none !important", margin: "0px !important" }}
        />
      </div>
    ),
    link: "https://amzn.to/34ubgf0",
    description:
      "Can easily detangle well prepared hair while massaging the scalp, comfortable grip and lightweight",
    option: [
      "1 and 1",
      "1 and 2",
      "1 and 3",
      "2 and 1",
      "2 and 2",
      "2 and 3",
      "3 and 1",
      "3 and 2",
      "3 and 3"
    ]
  },
  {
    id: 3,
    type: "product",
    title: "Cantu Coconut Curling Cream",
    imgSrc: (
      <div>
        <a
          href="https://www.amazon.com/Cantu-Coconut-Curling-Cream-Ounce/dp/B01LTIAU6A/ref=as_li_ss_il?dchild=1&keywords=natural+hair+products&qid=1586795769&rnid=2661617011&sr=8-10&linkCode=li2&tag=natural032d-20&linkId=aeff785526b049d799c117857e9b787a&language=en_US"
          target="_blank"
        >
          <img
            border="0"
            src="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B01LTIAU6A&Format=_SL160_&ID=AsinImage&MarketPlace=US&ServiceVersion=20070822&WS=1&tag=natural032d-20&language=en_US"
          />
        </a>
        <img
          src="https://ir-na.amazon-adsystem.com/e/ir?t=natural032d-20&language=en_US&l=li2&o=1&a=B01LTIAU6A"
          width="1"
          height="1"
          border="0"
          alt=""
          style={{ border: "none !important", margin: "0px !important" }}
        />
      </div>
    ),
    link: "https://amzn.to/3a6fVFd",
    description:
      "Strengthens and moisturises hair, lightweight so creates definition without weighing hair down",
    option: ["1 and 2", "2 and 2", "2 and 3"]
  },
  {
    id: 4,
    type: "product",
    title: "Cantu Grow Strong Strengthening Treatment",
    imgSrc: (
      <div>
        <a
          href="https://www.amazon.com/Cantu-Strong-Strengthening-Treatment-Ounce/dp/B01LTIAUEC/ref=as_li_ss_il?dchild=1&keywords=natural+hair+products&qid=1586796069&rnid=2941120011&s=beauty&sr=1-2&linkCode=li2&tag=natural032d-20&linkId=d4f9778310acdd0b5837fcb1964b3c17&language=en_US"
          target="_blank"
        >
          <img
            border="0"
            src="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B01LTIAUEC&Format=_SL160_&ID=AsinImage&MarketPlace=US&ServiceVersion=20070822&WS=1&tag=natural032d-20&language=en_US"
          />
        </a>
        <img
          src="https://ir-na.amazon-adsystem.com/e/ir?t=natural032d-20&language=en_US&l=li2&o=1&a=B01LTIAUEC"
          width="1"
          height="1"
          border="0"
          alt=""
          style={{ border: "none !important", margin: "0px !important" }}
        />
      </div>
    ),
    link: "https://amzn.to/3b7X11Z",
    description:
      "Strengthens hair and encourages growth, pure shea butter ingredient helps give deep moisture",
    option: ["1 and 2", "2 and 2"]
  },
  {
    id: 5,
    type: "product",
    title: "Cantu Shea Butter Hydrating Cream Conditioner",
    imgSrc: (
      <div>
        <a
          href="https://www.amazon.com/Cantu-Butter-Natural-Hydrating-Conditioner/dp/B00NMM8JYM/ref=as_li_ss_il?dchild=1&keywords=natural+hair+products&qid=1586795769&rnid=2661617011&sr=8-25&linkCode=li2&tag=natural032d-20&linkId=07cc273529e68d80aafd5cfd5f19a762&language=en_US"
          target="_blank"
        >
          <img
            border="0"
            src="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B00NMM8JYM&Format=_SL160_&ID=AsinImage&MarketPlace=US&ServiceVersion=20070822&WS=1&tag=natural032d-20&language=en_US"
          />
        </a>
        <img
          src="https://ir-na.amazon-adsystem.com/e/ir?t=natural032d-20&language=en_US&l=li2&o=1&a=B00NMM8JYM"
          width="1"
          height="1"
          border="0"
          alt=""
          style={{ border: "none !important", margin: "0px !important" }}
        />
      </div>
    ),
    link: "https://amzn.to/2xsedQX",
    description:
      "Aimed at customers with natural hair, great for hydration when it works but doesn't work for everyone",
    option: ["1 and 1", "2 and 1", "2 and 2"]
  },
  {
    id: 6,
    type: "product",
    title: "Cantu Shea Butter Hydrating Conditioning Mist",
    imgSrc: (
      <div>
        <a
          href="https://www.amazon.com/Cantu-Butter-Hydrating-Leave-Conditioning/dp/B01LTIAUFQ/ref=as_li_ss_il?dchild=1&keywords=natural+hair+products&qid=1586795769&rnid=2661617011&sr=8-43&linkCode=li2&tag=natural032d-20&linkId=c1f854c29e4ae4be3932e49ff03d0c81&language=en_US"
          target="_blank"
        >
          <img
            border="0"
            src="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B01LTIAUFQ&Format=_SL160_&ID=AsinImage&MarketPlace=US&ServiceVersion=20070822&WS=1&tag=natural032d-20&language=en_US"
          />
        </a>
        <img
          src="https://ir-na.amazon-adsystem.com/e/ir?t=natural032d-20&language=en_US&l=li2&o=1&a=B01LTIAUFQ"
          width="1"
          height="1"
          border="0"
          alt=""
          style={{ border: "none !important", margin: "0px !important" }}
        />
      </div>
    ),
    link: "https://amzn.to/2yZ7DSD",
    description:
      "Hydrating leave in conditioning mist, does a good job of adding moisture and can be used daily",
    option: ["1 and 1", "1 and 2", "2 and 1"]
  },
  {
    id: 7,
    type: "product",
    title: "Cantu Sulfate-Free Cleansing Cream Shampoo",
    imgSrc: (
      <div>
        <a
          href="https://www.amazon.com/Cantu-Sulfate-Free-Cleansing-Cream-Shampoo/dp/B01LTIAU9W/ref=as_li_ss_il?dchild=1&keywords=natural+hair+products&qid=1586796025&rnid=2941120011&s=beauty&sr=1-4&linkCode=li2&tag=natural032d-20&linkId=c4b79d0fe2bb4af03a0dc3c30c809334&language=en_US"
          target="_blank"
        >
          <img
            border="0"
            src="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B01LTIAU9W&Format=_SL160_&ID=AsinImage&MarketPlace=US&ServiceVersion=20070822&WS=1&tag=natural032d-20&language=en_US"
          />
        </a>
        <img
          src="https://ir-na.amazon-adsystem.com/e/ir?t=natural032d-20&language=en_US&l=li2&o=1&a=B01LTIAU9W"
          width="1"
          height="1"
          border="0"
          alt=""
          style={{ border: "none !important", margin: "0px !important" }}
        />
      </div>
    ),
    link: "https://amzn.to/2VphkkT",
    description:
      "Gently cleans and lathers nicely, great for controlling frizz and moisturising hair",
    option: [
      "1 and 1",
      "1 and 3",
      "2 and 1",
      "2 and 3",
      "3 and 1",
      "3 and 2",
      "3 and 3"
    ]
  },
  {
    id: 8,
    type: "product",
    title: "Cantu Shea Butter Daily Oil Moisturizer",
    imgSrc: (
      <div>
        <a
          href="https://www.amazon.com/Cantu-Butter-Daily-Moisturizer-Ounce/dp/B01LTIAU88/ref=as_li_ss_il?dchild=1&keywords=natural+hair+products&qid=1586796069&rnid=2941120011&s=beauty&sr=1-5&linkCode=li2&tag=natural032d-20&linkId=f92e4f3aca7064dbaf1a32c54757e3b1&language=en_US"
          target="_blank"
        >
          <img
            border="0"
            src="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B01LTIAU88&Format=_SL160_&ID=AsinImage&MarketPlace=US&ServiceVersion=20070822&WS=1&tag=natural032d-20&language=en_US"
          />
        </a>
        <img
          src="https://ir-na.amazon-adsystem.com/e/ir?t=natural032d-20&language=en_US&l=li2&o=1&a=B01LTIAU88"
          width="1"
          height="1"
          border="0"
          alt=""
          style={{ border: "none !important", margin: "0px !important" }}
        />
      </div>
    ),
    link: "https://amzn.to/34AycJj",
    description:
      "Does well to add long lasting moisture, oil based so keeps hair conditioned but not greasy",
    option: ["1 and 2", "1 and 3", "2 and 2", "2 and 3"]
  },
  {
    id: 9,
    type: "product",
    title: "Aunt Jackie's Curl La La Defining Curl Custard",
    imgSrc: (
      <div>
        <a
          href="https://www.amazon.com/Aunt-Jackies-Lightweight-Mega-moisture-Humectants/dp/B00OVQUQHG/ref=as_li_ss_il?dchild=1&keywords=natural+hair+products&qid=1586795769&rnid=2661617011&sr=8-1&linkCode=li2&tag=natural032d-20&linkId=58d38de2631b8933294472cbb8b597b1&language=en_US"
          target="_blank"
        >
          <img
            border="0"
            src="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B00OVQUQHG&Format=_SL160_&ID=AsinImage&MarketPlace=US&ServiceVersion=20070822&WS=1&tag=natural032d-20&language=en_US"
          />
        </a>
        <img
          src="https://ir-na.amazon-adsystem.com/e/ir?t=natural032d-20&language=en_US&l=li2&o=1&a=B00OVQUQHG"
          width="1"
          height="1"
          border="0"
          alt=""
          style={{ border: "none !important", margin: "0px !important" }}
        />
      </div>
    ),
    link: "https://amzn.to/3b29yns",
    description:
      "Lightweight custard that helps define curls and add moisture, apply to damp hair for best results",
    option: ["2 and 2", "3 and 2"]
  },
  {
    id: 10,
    type: "product",
    title: "Aunt Jackie's Don't Shrink Curling Gel",
    imgSrc: (
      <div>
        <a
          href="https://www.amazon.com/Aunt-Jackies-Flaxseed-Elongating-Curling/dp/B00MKCMDMY/ref=as_li_ss_il?dchild=1&keywords=natural+hair+products&qid=1586795769&rnid=2661617011&sr=8-2&linkCode=li2&tag=natural032d-20&linkId=bef1747b51c0565d744766fac7dd0d91&language=en_US"
          target="_blank"
        >
          <img
            border="0"
            src="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B00MKCMDMY&Format=_SL160_&ID=AsinImage&MarketPlace=US&ServiceVersion=20070822&WS=1&tag=natural032d-20&language=en_US"
          />
        </a>
        <img
          src="https://ir-na.amazon-adsystem.com/e/ir?t=natural032d-20&language=en_US&l=li2&o=1&a=B00MKCMDMY"
          width="1"
          height="1"
          border="0"
          alt=""
          style={{ border: "none !important", margin: "0px !important" }}
        />
      </div>
    ),
    link: "https://amzn.to/2V6zSaI",
    description:
      "Contains flaxseed and wheat protein, does a good job for hair growth and great for scalp health",
    option: ["1 and 3", "2 and 1", "2 and 2", "2 and 3"]
  },
  {
    id: 11,
    type: "product",
    title: "Aunt Jackie's Oh So Clean Shampoo",
    imgSrc: (
      <div>
        <a
          href="https://www.amazon.com/Aunt-Jackies-Lather-rich-Moisturizing-Enriched/dp/B008R42AA4/ref=as_li_ss_il?dchild=1&keywords=natural+hair+products&qid=1586796025&rnid=2941120011&s=beauty&sr=1-2&linkCode=li2&tag=natural032d-20&linkId=5517dddb312a8bbcd9c737e4c44d6d08&language=en_US"
          target="_blank"
        >
          <img
            border="0"
            src="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B008R42AA4&Format=_SL160_&ID=AsinImage&MarketPlace=US&ServiceVersion=20070822&WS=1&tag=natural032d-20&language=en_US"
          />
        </a>
        <img
          src="https://ir-na.amazon-adsystem.com/e/ir?t=natural032d-20&language=en_US&l=li2&o=1&a=B008R42AA4"
          width="1"
          height="1"
          border="0"
          alt=""
          style={{ border: "none !important", margin: "0px !important" }}
        />
      </div>
    ),
    link: "https://amzn.to/2XyE8Bm",
    description:
      "Made especially for dry hair, it gets mixed reviews but you'll have a great addition if it works for you",
    option: ["3 and 2"]
  },
  {
    id: 12,
    type: "product",
    title: "Aunt Jackie's Knot On My Watch Leave-in Detangler",
    imgSrc: (
      <div>
        <a
          href="https://www.amazon.com/Aunt-Jackies-Instant-Detangling-Enriched/dp/B008R40C22/ref=as_li_ss_il?dchild=1&keywords=natural+hair+products&qid=1586795769&rnid=2661617011&sr=8-7&th=1&linkCode=li2&tag=natural032d-20&linkId=e9dfd167e6e6fa9448b3135b1d15bf07&language=en_US"
          target="_blank"
        >
          <img
            border="0"
            src="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B008R40C22&Format=_SL160_&ID=AsinImage&MarketPlace=US&ServiceVersion=20070822&WS=1&tag=natural032d-20&language=en_US"
          />
        </a>
        <img
          src="https://ir-na.amazon-adsystem.com/e/ir?t=natural032d-20&language=en_US&l=li2&o=1&a=B008R40C22"
          width="1"
          height="1"
          border="0"
          alt=""
          style={{ border: "none !important", margin: "0px !important" }}
        />
      </div>
    ),
    link: "https://amzn.to/2ygkPlr",
    description:
      "light weight product that works magic for detangling hair, contains shea butter and olive oil",
    option: ["1 and 1", "1 and 2", "2 and 1", "3 and 1", "3 and 2"]
  },
  {
    id: 13,
    type: "product",
    title: "Aunt Jackie's Fix My Hair, Conditioning Masque",
    imgSrc: (
      <div>
        <a
          href="https://www.amazon.com/Aunt-Jackies-Flaxseed-Intensive-Conditioning/dp/B01ANZYSIQ/ref=as_li_ss_il?dchild=1&keywords=natural+hair+products&qid=1586795769&rnid=2661617011&sr=8-13&linkCode=li2&tag=natural032d-20&linkId=5feff040b5d0225f1829a13d6b3c0909&language=en_US"
          target="_blank"
        >
          <img
            border="0"
            src="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B01ANZYSIQ&Format=_SL160_&ID=AsinImage&MarketPlace=US&ServiceVersion=20070822&WS=1&tag=natural032d-20&language=en_US"
          />
        </a>
        <img
          src="https://ir-na.amazon-adsystem.com/e/ir?t=natural032d-20&language=en_US&l=li2&o=1&a=B01ANZYSIQ"
          width="1"
          height="1"
          border="0"
          alt=""
          style={{ border: "none !important", margin: "0px !important" }}
        />
      </div>
    ),
    link: "https://amzn.to/2yblEw0",
    description:
      "Deep conditioning wash out hair masque, a favourite of so many customers, amazing for moisture absorbtion",
    option: ["1 and 1", "1 and 2", "2 and 1"]
  },
  {
    id: 14,
    type: "product",
    title: "Aunt Jackie's Seal It Up, Hydrating Sealing Butter",
    imgSrc: (
      <div>
        <a
          href="https://www.amazon.com/Aunt-Jackies-Flaxseed-Recipes-Hydrating/dp/B01AM4UM5Q/ref=as_li_ss_il?dchild=1&keywords=natural+hair+products&qid=1586796069&rnid=2941120011&s=beauty&sr=1-1&linkCode=li2&tag=natural032d-20&linkId=4743d1f344febd70235dd01db717c9fb&language=en_US"
          target="_blank"
        >
          <img
            border="0"
            src="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B01AM4UM5Q&Format=_SL160_&ID=AsinImage&MarketPlace=US&ServiceVersion=20070822&WS=1&tag=natural032d-20&language=en_US"
          />
        </a>
        <img
          src="https://ir-na.amazon-adsystem.com/e/ir?t=natural032d-20&language=en_US&l=li2&o=1&a=B01AM4UM5Q"
          width="1"
          height="1"
          border="0"
          alt=""
          style={{ border: "none !important", margin: "0px !important" }}
        />
      </div>
    ),
    link: "https://amzn.to/2yfIWkg",
    description:
      "Great for protecting thicker hair, helps reduce frizz, strengthens and hydrates",
    option: ["1 and 2"]
  },
  {
    id: 15,
    type: "product",
    title: "Wild Growth Hair Oil",
    imgSrc: (
      <div>
        <a
          href="https://www.amazon.com/Wild-Growth-Hair-Oil-Oz/dp/B000V8MTIC/ref=as_li_ss_il?dchild=1&keywords=natural+hair+products&qid=1586795769&rnid=2661617011&sr=8-3&th=1&linkCode=li2&tag=natural032d-20&linkId=a851d53d98729b0ae9035124c5299e41&language=en_US"
          target="_blank"
        >
          <img
            border="0"
            src="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B000V8MTIC&Format=_SL160_&ID=AsinImage&MarketPlace=US&ServiceVersion=20070822&WS=1&tag=natural032d-20&language=en_US"
          />
        </a>
        <img
          src="https://ir-na.amazon-adsystem.com/e/ir?t=natural032d-20&language=en_US&l=li2&o=1&a=B000V8MTIC"
          width="1"
          height="1"
          border="0"
          alt=""
          style={{ border: "none !important", margin: "0px !important" }}
        />
      </div>
    ),
    link: "https://amzn.to/34z3Rel",
    description:
      "Mixed reviews with this, some people love it and saw results quickly, others would not recommend",
    option: ["1 and 2"]
  },
  {
    id: 16,
    type: "product",
    title: "Design Essentials Sulfate-Free Conditioner",
    imgSrc: (
      <div>
        <a
          href="https://www.amazon.com/Design-Essentials-Moisturizing-Sulfate-Free-Conditioner/dp/B0177XWLQI/ref=as_li_ss_il?dchild=1&keywords=natural+hair+products&qid=1586795769&rnid=2661617011&sr=8-4&linkCode=li2&tag=natural032d-20&linkId=b22fb96916a63e364070c2c5e5532581&language=en_US"
          target="_blank"
        >
          <img
            border="0"
            src="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B0177XWLQI&Format=_SL160_&ID=AsinImage&MarketPlace=US&ServiceVersion=20070822&WS=1&tag=natural032d-20&language=en_US"
          />
        </a>
        <img
          src="https://ir-na.amazon-adsystem.com/e/ir?t=natural032d-20&language=en_US&l=li2&o=1&a=B0177XWLQI"
          width="1"
          height="1"
          border="0"
          alt=""
          style={{ border: "none !important", margin: "0px !important" }}
        />
      </div>
    ),
    link: "https://amzn.to/2K68lQh",
    description:
      "Almond and Avocado moisturising & detangling conditioner, for long lasting hydration and handling frizz",
    option: ["1 and 2", "1 and 3", "2 and 1", "2 and 2", "2 and 3"]
  },
  {
    id: 17,
    type: "product",
    title: "Yanibest Satin Lined Bonnet",
    imgSrc: (
      <div>
        <a
          href="https://www.amazon.com/YANIBEST-Extra-Adjustable-Slouchy-Beanie/dp/B07MPWR2H7/ref=as_li_ss_il?dchild=1&keywords=natural+hair+products&qid=1586795769&rnid=2661617011&sr=8-5&th=1&psc=1&linkCode=li2&tag=natural032d-20&linkId=0818e2b78f515c4e181e693d1dcbf1fa&language=en_US"
          target="_blank"
        >
          <img
            border="0"
            src="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B07MPWR2H7&Format=_SL160_&ID=AsinImage&MarketPlace=US&ServiceVersion=20070822&WS=1&tag=natural032d-20&language=en_US"
          />
        </a>
        <img
          src="https://ir-na.amazon-adsystem.com/e/ir?t=natural032d-20&language=en_US&l=li2&o=1&a=B07MPWR2H7"
          width="1"
          height="1"
          border="0"
          alt=""
          style={{ border: "none !important", margin: "0px !important" }}
        />
      </div>
    ),
    link: "https://amzn.to/34BgV2S",
    description:
      "Adjustable satin lined sleep cap, soft, breathable and stays on all night",
    option: [
      "1 and 1",
      "1 and 2",
      "1 and 3",
      "2 and 1",
      "2 and 2",
      "2 and 3",
      "3 and 1",
      "3 and 2",
      "3 and 3"
    ]
  },
  {
    id: 18,
    type: "product",
    title: "Maui Moisture Curl Quench",
    imgSrc: (
      <div>
        <a
          href="https://www.amazon.com/Maui-Moisture-Silicone-Detangle-Definition/dp/B01MXCO41V/ref=as_li_ss_il?dchild=1&keywords=natural+hair+products&qid=1586795769&rnid=2661617011&sr=8-9&linkCode=li2&tag=natural032d-20&linkId=59ff683f362f3306476f6d559366df9d&language=en_US"
          target="_blank"
        >
          <img
            border="0"
            src="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B01MXCO41V&Format=_SL160_&ID=AsinImage&MarketPlace=US&ServiceVersion=20070822&WS=1&tag=natural032d-20&language=en_US"
          />
        </a>
        <img
          src="https://ir-na.amazon-adsystem.com/e/ir?t=natural032d-20&language=en_US&l=li2&o=1&a=B01MXCO41V"
          width="1"
          height="1"
          border="0"
          alt=""
          style={{ border: "none !important", margin: "0px !important" }}
        />
      </div>
    ),
    link: "https://amzn.to/2V9ddud",
    description:
      "Adds moisture to hair without leaving streaks when drying, nourishes and defines curls",
    option: ["1 and 2"]
  },
  {
    id: 19,
    type: "product",
    title: "African Pride Moisture Miracle Pre-Shampoo",
    imgSrc: (
      <div>
        <a
          href="https://www.amazon.com/AFRICAN-MOISTURE-DETANGLE-CONDITION-PRE-SHAMPOO/dp/B07F6NWJCL/ref=as_li_ss_il?dchild=1&keywords=natural+hair+products&qid=1586795769&rnid=2661617011&sr=8-17&linkCode=li2&tag=natural032d-20&linkId=9c4f4a1148623c0f8e45629cde7b2dd9&language=en_US"
          target="_blank"
        >
          <img
            border="0"
            src="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B07F6NWJCL&Format=_SL160_&ID=AsinImage&MarketPlace=US&ServiceVersion=20070822&WS=1&tag=natural032d-20&language=en_US"
          />
        </a>
        <img
          src="https://ir-na.amazon-adsystem.com/e/ir?t=natural032d-20&language=en_US&l=li2&o=1&a=B07F6NWJCL"
          width="1"
          height="1"
          border="0"
          alt=""
          style={{ border: "none !important", margin: "0px !important" }}
        />
      </div>
    ),
    link: "https://amzn.to/2VsRV9N",
    description:
      "Pre shampoo for detangling and retaining moisture, leave in for up to 30mins and rinse for nourished hair",
    option: ["1 and 1", "1 and 2", "2 and 1"]
  },
  {
    id: 20,
    type: "product",
    title: "Blue Magic Indian Hemp Conditioner",
    imgSrc: (
      <div>
        <a
          href="https://www.amazon.com/Blue-Magic-Indian-Conditioner-Ounce/dp/B005DI4ZJQ/ref=as_li_ss_il?dchild=1&keywords=natural+hair+products&qid=1586795769&rnid=2661617011&sr=8-21&linkCode=li2&tag=natural032d-20&linkId=da4b49618929abe1cff876915361f216&language=en_US"
          target="_blank"
        >
          <img
            border="0"
            src="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B005DI4ZJQ&Format=_SL160_&ID=AsinImage&MarketPlace=US&ServiceVersion=20070822&WS=1&tag=natural032d-20&language=en_US"
          />
        </a>
        <img
          src="https://ir-na.amazon-adsystem.com/e/ir?t=natural032d-20&language=en_US&l=li2&o=1&a=B005DI4ZJQ"
          width="1"
          height="1"
          border="0"
          alt=""
          style={{ border: "none !important", margin: "0px !important" }}
        />
      </div>
    ),
    link: "https://amzn.to/2Vqsh5I",
    description:
      "Smells good and you can actually see the ingredients, leaves hair conditioned and helps alleviate dry scalp",
    option: ["1 and 1", "2 and 1"]
  },
  {
    id: 21,
    type: "product",
    title: "Shea Moisture Jamaican Strengthen & Restore Conditioner",
    imgSrc: (
      <div>
        <a
          href="https://www.amazon.com/Shea-Moisture-Jamaican-Strengthen-Conditioner/dp/B00V6GPXZO/ref=as_li_ss_il?dchild=1&keywords=natural+hair+products&qid=1586795769&rnid=2661617011&sr=8-29&linkCode=li2&tag=natural032d-20&linkId=0b395cb406022ffc1fc02d1f940c5165&language=en_US"
          target="_blank"
        >
          <img
            border="0"
            src="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B00V6GPXZO&Format=_SL160_&ID=AsinImage&MarketPlace=US&ServiceVersion=20070822&WS=1&tag=natural032d-20&language=en_US"
          />
        </a>
        <img
          src="https://ir-na.amazon-adsystem.com/e/ir?t=natural032d-20&language=en_US&l=li2&o=1&a=B00V6GPXZO"
          width="1"
          height="1"
          border="0"
          alt=""
          style={{ border: "none !important", margin: "0px !important" }}
        />
      </div>
    ),
    link: "https://amzn.to/2V8kdY9",
    description:
      "Contains Jamaican black castor oil, leaves hair soft and with shine, light so doesn't weigh the hair down",
    option: ["2 and 3", "3 and 2", "3 and 3"]
  },
  {
    id: 22,
    type: "product",
    title: "Design Essentials Super Moisturizing Conditioner",
    imgSrc: (
      <div>
        <a
          href="https://www.amazon.com/Design-Essentials-Stimulating-Moisturizing-Conditioner/dp/B01CKJD4F6/ref=as_li_ss_il?dchild=1&keywords=natural+hair+products&qid=1586795769&rnid=2661617011&sr=8-34&th=1&linkCode=li2&tag=natural032d-20&linkId=9d74dcc65de46eaa76b8b1137dd4c5dc&language=en_US"
          target="_blank"
        >
          <img
            border="0"
            src="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B01CKJD4F6&Format=_SL160_&ID=AsinImage&MarketPlace=US&ServiceVersion=20070822&WS=1&tag=natural032d-20&language=en_US"
          />
        </a>
        <img
          src="https://ir-na.amazon-adsystem.com/e/ir?t=natural032d-20&language=en_US&l=li2&o=1&a=B01CKJD4F6"
          width="1"
          height="1"
          border="0"
          alt=""
          style={{ border: "none !important", margin: "0px !important" }}
        />
      </div>
    ),
    link: "https://amzn.to/2yREIzF",
    description:
      "Light weight and helps with hydration, it gets great reviews and works wonders for hair and scalp",
    option: [
      "1 and 1",
      "1 and 2",
      "1 and 3",
      "2 and 1",
      "2 and 3",
      "3 and 1",
      "3 and 2",
      "3 and 3"
    ]
  },
  {
    id: 23,
    type: "product",
    title: "Design Essentials Natural Curl Defining Gelee",
    imgSrc: (
      <div>
        <a
          href="https://www.amazon.com/Design-Essentials-Gelee-Lightweight-Frizz-Free-Hold-Coconut/dp/B01DKNAMHY/ref=as_li_ss_il?dchild=1&keywords=natural+hair+products&qid=1586795769&rnid=2661617011&sr=8-44&linkCode=li2&tag=natural032d-20&linkId=f1dd026fd680c48c290f53939dbd0278&language=en_US"
          target="_blank"
        >
          <img
            border="0"
            src="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B01DKNAMHY&Format=_SL160_&ID=AsinImage&MarketPlace=US&ServiceVersion=20070822&WS=1&tag=natural032d-20&language=en_US"
          />
        </a>
        <img
          src="https://ir-na.amazon-adsystem.com/e/ir?t=natural032d-20&language=en_US&l=li2&o=1&a=B01DKNAMHY"
          width="1"
          height="1"
          border="0"
          alt=""
          style={{ border: "none !important", margin: "0px !important" }}
        />
      </div>
    ),
    link: "https://amzn.to/2z0jyj4",
    description:
      "Enhances texture of the hair and reduces frizz, great for locking in moisture and works well with other products",
    option: ["1 and 2", "2 and 2", "3 and 2"]
  },
  {
    id: 24,
    type: "product",
    title: "tgin Honey Miracle Hair Mask",
    imgSrc: (
      <div>
        <a
          href="https://www.amazon.com/Honey-Miracle-Conditioner-Natural-Olive/dp/B00FN3EIS4/ref=as_li_ss_il?dchild=1&keywords=natural+hair+products&qid=1586795947&rnid=2661617011&sr=8-63&linkCode=li2&tag=natural032d-20&linkId=1aa4177d3c520443722d33d964f244d7&language=en_US"
          target="_blank"
        >
          <img
            border="0"
            src="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B00FN3EIS4&Format=_SL160_&ID=AsinImage&MarketPlace=US&ServiceVersion=20070822&WS=1&tag=natural032d-20&language=en_US"
          />
        </a>
        <img
          src="https://ir-na.amazon-adsystem.com/e/ir?t=natural032d-20&language=en_US&l=li2&o=1&a=B00FN3EIS4"
          width="1"
          height="1"
          border="0"
          alt=""
          style={{ border: "none !important", margin: "0px !important" }}
        />
      </div>
    ),
    link: "https://amzn.to/2RE3TfA",
    description:
      "Deep conditioning hair mask that moisturises hair and adds shine, also hydrates dry itchy scalp",
    option: ["1 and 1"]
  },
  {
    id: 25,
    type: "product",
    title: "OKAY Black Jamaican Castor Oil Shampoo",
    imgSrc: (
      <div>
        <a
          href="https://www.amazon.com/Okay-Jamaican-Castor-Moisture-Shampoo/dp/B00DPNKDR4/ref=as_li_ss_il?dchild=1&keywords=natural+hair+products&qid=1586796025&rnid=2941120011&s=beauty&sr=1-13&linkCode=li2&tag=natural032d-20&linkId=0ec8d94c1c840d7ba40784fbcb79bad3&language=en_US"
          target="_blank"
        >
          <img
            border="0"
            src="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B00DPNKDR4&Format=_SL160_&ID=AsinImage&MarketPlace=US&ServiceVersion=20070822&WS=1&tag=natural032d-20&language=en_US"
          />
        </a>
        <img
          src="https://ir-na.amazon-adsystem.com/e/ir?t=natural032d-20&language=en_US&l=li2&o=1&a=B00DPNKDR4"
          width="1"
          height="1"
          border="0"
          alt=""
          style={{ border: "none !important", margin: "0px !important" }}
        />
      </div>
    ),
    link: "https://amzn.to/2RBC1Jb",
    description:
      "Cleansing shampoo that helps restore dry damaged hair, also nourishes the scalp, contains argan oil",
    option: ["1 and 1", "2 and 1"]
  }
];

export default data;
